"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const product = (sdk) => {
    const { sdkConfig: { url }, defaultVersion, } = sdk;
    const httpClient = sdk.httpClient;
    return {
        getProduct: async (productId, query) => {
            const endpoint = `${url}/v4/products/${productId}`;
            const result = await httpClient.get(endpoint, { query });
            return result.data;
        },
        getProductsByQuery: async (query = {}, options = {}) => {
            const endpoint = `${url}/v4/products`;
            const result = await httpClient.get(endpoint, {
                query: Object.assign(Object.assign({}, query), options),
            });
            return result.data;
        },
        getProductMindItems: async (productId) => {
            const endpoint = `${url}/v4/products/${productId}/mindItems`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        manageItemInMultipleCollections: async (productId, payload) => {
            const endpoint = `${url}/${defaultVersion}/products/${productId}/manageItemInMultipleCollections`;
            const result = await httpClient.put(endpoint, { payload });
            return result.data;
        },
        pinProduct: async (productId) => {
            const endpoint = `${url}/v4/products/${productId}/pin`;
            const result = await httpClient.put(endpoint);
            return result.data;
        },
        unpinProduct: async (productId) => {
            const endpoint = `${url}/v4/products/${productId}/unpin`;
            await httpClient.put(endpoint);
            return;
        },
        getAttachments: async (productId) => {
            const endpoint = `${url}/v4/products/${productId}/attachments`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getAttachmentZipLink: async (zipId) => {
            const endpoint = `${url}/v4/products/zip/${zipId}`;
            const result = await httpClient.get(endpoint, { hideProgress: true });
            return result.data;
        },
        handleProductAttachmentsDownload: async (productId, payload) => {
            const endpoint = `${url}/v4/products/${productId}/attachments/download`;
            const result = await httpClient.post(endpoint, { payload });
            return result.data;
        },
        search: async (searchParams, abortSignal) => {
            const endpoint = `${url}/v4/products/search`;
            const result = await httpClient.get(endpoint, { query: searchParams, abortSignal });
            return result;
        },
    };
};
exports.default = product;
